export default function GS_Formulas() {
  return (
    <div className="p-4">
      <h1>GS Formulas</h1>
    </div>
  );
}
